<template>
    <div>
        <h3>Contracts</h3>
        <b-row>
        <b-col sm="10">
          <b-form inline @submit.prevent="" class="mb-2">
            <b-input-group class="filter-group mr-2">
              <b-input-group-prepend is-text>
                  <font-awesome-icon icon="search" />
              </b-input-group-prepend>
              <b-form-input v-model="filter" placeholder="Type to Search" debounce="500"></b-form-input>
              <b-input-group-append>
                <b-button @click="filter = null">Clear</b-button>
              </b-input-group-append>
            </b-input-group>
            <b-input-group class="filter-group mr-2">
              <b-input-group-prepend is-text class="semester-input-group">
                Start Term
              </b-input-group-prepend>
              <b-form-select v-model="startTerm"
                            :options="terms"
                            value-field="termId"
                            text-field="description">

                <template slot="first">
                  <!-- this slot appears above the options from 'options' prop -->
                  <option :value="null">All</option>
                </template>
              </b-form-select>
             </b-input-group>
             <b-input-group class="filter-group mr-2">
              <b-input-group-prepend is-text class="semester-input-group">
                End Term
              </b-input-group-prepend>
              <b-form-select v-model="endTerm"
                            :options="terms"
                            value-field="termId"
                            text-field="description">

                <template slot="first">
                  <!-- this slot appears above the options from 'options' prop -->
                  <option :value="null">All</option>
                </template>
              </b-form-select>
             </b-input-group>
          </b-form>
        </b-col>
        <b-col sm="2">
          <b-button v-if="isContractManager" :to="{ name: 'contractAdd' }" class="new-content-button"><font-awesome-icon icon="plus" /> Add New Contract</b-button>
        </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form inline @submit.prevent="" class="mb-2">
            <b-input-group class="filter-group mr-2">
              <b-input-group-prepend is-text class="semester-input-group">
                Contract Stage
              </b-input-group-prepend>
              <b-form-select v-model="contractStage"
                            :options="contractStages"
                            value-field="contractStageDefinitionId"
                            text-field="name">
                <template slot="first">
                  <!-- this slot appears above the options from 'options' prop -->
                  <option :value="null">All</option>
                </template>
              </b-form-select>
             </b-input-group>
             <b-input-group class="filter-group mr-2">
              <b-input-group-prepend is-text class="semester-input-group">
                Contract Status
              </b-input-group-prepend>
              <b-form-select v-model="contractStatus"
                            :options="contractStatuses"
                            value-field="contractStatusDefinitionId"
                            text-field="name">
                <template slot="first">
                  <!-- this slot appears above the options from 'options' prop -->
                  <option :value="null">All</option>
                </template>
              </b-form-select>
             </b-input-group>

             <b-input-group class="filter-group mr-2">
              <b-input-group-prepend is-text class="semester-input-group">
                Contract Type
              </b-input-group-prepend>
              <b-form-select v-model="contractType"
                            :options="contractTypes"
                            value-field="contractRestrictionTypeId"
                            text-field="description">
                <template slot="first">
                  <!-- this slot appears above the options from 'options' prop -->
                  <option :value="null">All</option>
                </template>
              </b-form-select>
             </b-input-group>
            </b-form>
          </b-col>
        </b-row>
        
        <div>
          <a :href="csvUrl">Download CSV</a>
        </div>

        <b-table striped
                 hover
                 :items="filteredItems"
                 :fields="fields"
                 :per-page="perPage"
                 :current-page="currentPage"
                 responsive>
          <template slot="termStart" slot-scope="data">
            {{ data.item.termStart ? data.item.termStart.description : "" }}
          </template>
          <template slot="termEnd" slot-scope="data">
            {{ data.item.termEnd ? data.item.termEnd.description : "" }}
          </template>
          <template slot="agreementType" slot-scope="data">
            {{ data.item.contractAgreementType.name }}
          </template>
          <template slot="modifiedDate" slot-scope="data">
            {{ data.item.modifiedDate | formatDate }}
          </template>
          <template slot="currentContractStage" slot-scope="data">
            {{ data.item.currentContractStage ? data.item.currentContractStage.name : "" }}
          </template>
          <template slot="currentContractStatus" slot-scope="data">
            {{ data.item.currentContractStatus ? data.item.currentContractStatus.name : "" }}
          </template>
          <template slot="edit" slot-scope="data">
            <router-link :to="{ name: 'contract', params: { id: data.item.contractId } }">View</router-link> 
          </template>
        </b-table>
        <b-pagination :total-rows="totalRows" v-model="currentPage" :per-page="perPage" align="right" />
    </div>
</template>

<script>
import { mapState } from "vuex";
import * as _ from "lodash"; // eslint-disable-line no-unused-vars
import roleChecks from "../../misc/role-checks";
import termsApi from "../../api/terms";
import contractsApi from "../../api/contracts";
export default {
  mixins: [roleChecks],
  data() {
    return {
      fields: [
        { key: "name", sortable: true },
        { key: "legalName", sortable: true },
        { key: "termStart", sortable: true },
        { key: "termEnd", sortable: true },
        { key: "agreementType", sortable: true },
        { key: "modifiedDate", sortable: true },
        { key: "currentContractStage", sortable: true },
        { key: "currentContractStatus", sortable: true },
        { key: "edit" }
      ],
      currentPage: 1,
      perPage: 20,
      totalRows: 0,
      filter: "",
      startTerm: null,
      endTerm: null,
      terms: [],
      contractStatuses: [],
      contractStatus: null,
      contractStages: [],
      contractStage: null,
      contractTypes: [],
      contractType: null
    };
  },

  computed: {
    ...mapState({
      user: state => state.auth.user
    }),
    csvUrl() {
      return process.env.VUE_APP_BASE_URI + "/api/contractReporting/exportcsv";
    },
    filteredItems: function() {
      var filtered = this.contracts;

      if (this.startTerm) {
        filtered = this.matchStartTerm(filtered, this.startTerm);
      }

      if (this.endTerm) {
        filtered = this.matchEndTerm(filtered, this.endTerm);
      }

      if (this.contractStage) {
        filtered = this.matchStage(filtered, this.contractStage);
      }

      if (this.contractStatus) {
        filtered = this.matchStatus(filtered, this.contractStatus);
      }

      if (this.contractType) {
        filtered = this.matchType(filtered, this.contractType);
      }

      filtered = this.search(filtered, this.filter);

      return filtered;
    }
  },

  props: {
    contracts: {
      type: Array,
      required: true
    }
  },

  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    matchStartTerm(collection, startTerm) {
      if (startTerm) {
        var term = _.filter(this.terms, term => {
          return term.termId === startTerm;
        })[0];

        if (term) {
          return _.filter(collection, item => {
            return (
              item.termStart &&
              parseInt(item.termStart.termCode) >= term.termCode
            );
          });
        }
      }
      return collection;
    },
    matchEndTerm(collection, endTerm) {
      if (endTerm) {
        var term = _.filter(this.terms, term => {
          return term.termId === endTerm;
        })[0];

        if (term) {
          return _.filter(collection, item => {
            return (
              item.termEnd && parseInt(item.termEnd.termCode) <= term.termCode
            );
          });
        }
      }
      return collection;
    },
    matchStage(collection, stage) {
      if (stage) {
        return _.filter(collection, item => {
          return item.currentContractStage.contractStageDefinitionId === stage;
        });
      }
      return collection;
    },
    matchStatus(collection, status) {
      if (status) {
        return _.filter(collection, item => {
          return (
            item.currentContractStatus.contractStatusDefinitionId === status
          );
        });
      }
      return collection;
    },
    matchType(collection, type) {
      if(type) {
        return _.filter(collection, item => {
          return item.contractRestrictionType.contractRestrictionTypeId === type;
        });
      }
      return collection;
    },
    search(collection, text) {
      var that = this;
      return _.filter(collection, function(object) {
        var search = that.deepSearch(object, text.toLowerCase());
        return _.keys(search).length > 0;
      });
    },

    deepSearch(collection, predicate, thisArg) {
      if (_.isFunction(predicate)) {
        predicate = _.iteratee(predicate, thisArg);
      } else {
        var keys = _.flatten(_.tail(arguments));
        if (typeof keys === "string") {
          keys = keys.toLowerCase();
        }
        predicate = function(val) {
          if (typeof val === "string") {
            val = val.toLowerCase();
          }
          return _.includes(val, keys);
        };
      }
      var that = this;
      return _.transform(collection, function(memo, val, key) {
        var include = predicate(val, key);
        if (!include && _.isObject(val)) {
          val = that.deepSearch(val, predicate);
          include = !_.isEmpty(val);
        }
        if (include) {
          _.isArray(collection) ? memo.push(val) : (memo[key] = val);
        }
      });
    }
  },
  watch: {
    filteredItems(items) {
      this.totalRows = items.length;
      this.currentPage = 1;
    }
  },
  created() {
    termsApi
      .getTerms()
      .then(response => {
        this.terms = response.data;
        this.startTerm = this.terms[0].termId;
        this.endTerm = this.terms[this.terms.length - 1].termId;
      })
      .catch(function(error) {
        console.log(error);
      });

    contractsApi.getContractStatusDefinitions().then(response => {
      this.contractStatuses = response.data;
    });

    contractsApi.getContractStageDefinitions().then(response => {
      this.contractStages = response.data;
    });

    contractsApi.getContractRestrictionTypes().then(response => {
      this.contractTypes = response.data;
    });
  }
};
</script>

<style scoped>
.filter-group {
  margin: 10px 0 15px 0;
  max-width: 600px;
}

.new-content-button {
  margin-left: 10px;
}
</style>
